import React, { useEffect, useState } from 'react';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Container, Row, Col, Card, Modal } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { RiRestartFill, RiSkipBackFill } from 'react-icons/ri';
import { FaCheck } from 'react-icons/fa';
import { FloatLabel } from 'primereact/floatlabel';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import EdisPaymentService, { invoiceDetails, paymentsHomPage, sbwcHomPage } from '../../services/payments/PenaltyPaymentService.ts';
import PenaltyPaymentService from '../../services/payments/PenaltyPaymentService.ts';

declare global {
  interface Window {
    tokenExpirationInterval: NodeJS.Timeout | null;
  }
}

const defaultInvoiceData: invoiceDetails = {

  invoiceNumber: 0,
  invoiceDate: '',
  complianceCaseDisplayNumber: '',
  legalBusinessName: '',
  invoiceAmount: 0,
  address: '',
  dueDate: '',
  email: '',
  paymentStatus: '',
  paymentDate: '',
  targetUrl: '',
  amountPaid: 0,
  companyEmail: '',
  serviceFee: 0,
  acknowledgementNumber: ''
};
const MEDIA_URL = process.env.REACT_APP_STATIC_MEDIA_URL;

const EdisPaymentComponent = () => {
  const paymentMethodOptions = [
    { label: 'Credit / Debit Card', value: 'card' },
    { label: 'ACH (e-check) Transfer', value: 'echeck' }
  ];

  const [error, setError] = useState('');
  const [paymentMethod, setPaymentMethod] = useState('');
  const [paymentMethodError, setPaymentMethodError] = useState('');


  const [errors, setErrors] = useState({
    invoiceNumber: '',
    referenceNumber: ''
  });
  const [formData, setFormData] = useState({
    invoiceNumber: '',
    referenceNumber: '',
  });
  const [invoiceData, setInvoiceData] = useState<invoiceDetails>(defaultInvoiceData);


  const [submittedData, setSubmittedData] = useState<invoiceDetails[]>([]);
  const [loading, setLoading] = useState(false);

  const [showPopup, setShowPopup] = useState(false);
  const [remainingTime, setRemainingTime] = useState<number | null>(null);
  const [hasDismissedPopup, setHasDismissedPopup] = useState(false);
  const [tokenExpirationInterval, setTokenExpirationInterval] = useState<NodeJS.Timeout | null>(null);
  const [emailError, setEmailError] = useState('');
  const navigate = useNavigate();


  useEffect(() => {
    return () => {
      if (window.tokenExpirationInterval) {
        clearInterval(window.tokenExpirationInterval);
      }
    };
  }, []);

  const handlePopupClose = () => {
    setShowPopup(false);
    setHasDismissedPopup(true);
  };



  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: ''
    }));
  };


  const handleDropdownChange = (e: any, field: string) => {

    const selectedValue = e.value as string;
    setPaymentMethod(selectedValue);
  };


  const fetchInvoiceData = async (event: React.FormEvent) => {
    event.preventDefault();
    setSubmittedData([]);
    setPaymentMethod('');
    setPaymentMethodError('');
    setEmailError('');
    setInvoiceData(defaultInvoiceData
    );
    let validationErrors = { invoiceNumber: '', referenceNumber: '' };
    let hasError = false;
    setError('');

    if (!formData.invoiceNumber.trim()) {
      validationErrors.invoiceNumber = 'Invoice number is required';
      hasError = true;
    }

    if (!formData.referenceNumber.trim()) {
      validationErrors.referenceNumber = 'Reference number is required';
      hasError = true;
    }

    setErrors(validationErrors);

    if (hasError) return;
    setLoading(true);

    try {
      const invoiceDataRes = await PenaltyPaymentService.penaltyPayment(formData);
      setInvoiceData(invoiceDataRes);

      setSubmittedData([invoiceDataRes]);
      const tokenExpiration = localStorage.getItem("paymentTokenExpiration");
      if (tokenExpiration) {
        startTokenExpirationTimer(tokenExpiration);
      }
      //setError('');
    } catch (error) {


      //setError('No Data Available');
      setInvoiceData(defaultInvoiceData);
      if (error.response) {
        const errorResponse = error.response.data;
        setError(errorResponse.message);
      }
      else {
        setError('Something went wrong. Please try again later.');
      }
      setSubmittedData([]);
      setLoading(false);


    }
    setLoading(false);


  };
  const validateEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (emailRegex.test(email)) {
      setEmailError('');
      return true;
    }
    else {
      setEmailError('Please enter a valid email address.');
      return false;
    }

  };
  const validatePaymentMethod = () => {
    if (!paymentMethod) {
      setPaymentMethodError('Please select a payment method.');
      return false;
    }
    return true;
  };


  const handleReset = () => {
    localStorage.removeItem("paymentToken");
    localStorage.removeItem("paymentTokenExpiration");
    setFormData({
      invoiceNumber: '',
      referenceNumber: '',
    });
    setInvoiceData(defaultInvoiceData);
    setErrors({ invoiceNumber: '', referenceNumber: '' });
    setSubmittedData([]);

    setShowPopup(false);
    setPaymentMethod('');
    setPaymentMethodError('');
    setEmailError('');
    navigate(0);
  }

  const handleToSBWCPage = () => {
    window.location.href = `${sbwcHomPage}`;
  };

  const handleProceedToPayment = () => {

    if (validateEmail(invoiceData.companyEmail) && validatePaymentMethod()) {
      setEmailError('');
      setPaymentMethodError('');

      navigate('/paymentprocessing', {
        state: {
          formData: formData,
          targetUrl: invoiceData.targetUrl,
          paymentMethod: paymentMethod,
          email: invoiceData.companyEmail,
          outStandingAmount: invoiceData.finalDueAmount
        }
      });
    }



  };


  const handlePaymentsHome = () => {
    window.location.href = `${paymentsHomPage}`;
  };



  const handleExtendSession = async () => {
    try {
      const token = localStorage.getItem("paymentToken");
      const tokenresponse = await EdisPaymentService.refreshToken(formData.invoiceNumber, formData.referenceNumber);


      if (tokenresponse.data.tokenExpiration) {
        localStorage.setItem("paymentTokenExpiration", tokenresponse.data.tokenExpiration);
        setShowPopup(false);
        setHasDismissedPopup(false);
        if (window.tokenExpirationInterval) {
          clearInterval(window.tokenExpirationInterval);
        }
        startTokenExpirationTimer(tokenresponse.data.tokenExpiration);
      }
    } catch (error) {
      console.error('Error extending the session:', error);
      alert('Error Occured while Extended session.')
      setShowPopup(false);
      setHasDismissedPopup(false);

    }
  };

  const startTokenExpirationTimer = (expirationTime) => {
    if (!expirationTime) return;

    console.log("Token Expiration Time:", expirationTime);

    const expirationTimestamp = new Date(expirationTime).getTime();
    const twoMinutesBefore = expirationTimestamp - 2 * 60 * 1000;

    // Clear any existing timer
    if (window.tokenExpirationInterval) {
      clearInterval(window.tokenExpirationInterval);
    }

    // Start the interval
    window.tokenExpirationInterval = setInterval(() => {
      const currentTime = new Date().getTime();

      // Show popup 2 minutes before expiration
      if (
        currentTime >= twoMinutesBefore &&
        currentTime < expirationTimestamp &&
        !hasDismissedPopup
      ) {
        setShowPopup(true);
        console.log("Session expiring soon. Showing popup.");
      }

      // Token has expired
      if (currentTime >= expirationTimestamp) {
        clearInterval(window.tokenExpirationInterval);

        // Cleanup actions
        setShowPopup(false); // Close popup
        setHasDismissedPopup(false); // Reset dismiss state
        localStorage.removeItem("paymentToken");
        localStorage.removeItem("paymentTokenExpiration");

        handleReset(); // Custom reset function
        console.log("Session expired. Data cleared and reset called.");
      }
    }, 1000);
  };

  const formatNumberWithCommas = (value: string | number): string => {
    if (typeof value === 'string') {
      // Remove all non-numeric characters except dot (.)
      value = value.replace(/[^0-9.]/g, '');
    }

    const num = Number(value);
    if (isNaN(num)) return '$0';

    return `$${num.toLocaleString('en-US', { minimumFractionDigits: 2 })}`;
  };

  const handleEmailChange = (e) => {
    const { name, value } = e.target;
    setInvoiceData({
      ...invoiceData,
      [name]: value
    });
  };

  const hasPenalty = submittedData.some(row => row?.penaltyAmount !== null);
  const hasDiscount = submittedData.some(row => row?.discountAmount !== null);
   const hasFinalAmount = submittedData.some(row => row?.finalDueAmount !== null);
  const showFinalAmount = hasPenalty || hasDiscount || hasFinalAmount;

  return (
    <div className="edispayment-container">
      {showPopup && !hasDismissedPopup && (
        <Modal show={showPopup} onHide={handlePopupClose} centered>
          <Modal.Header closeButton style={{ backgroundColor: '#0A3161', color: 'white' }}>
            <Modal.Title>Session Expiring Soon</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>Your session is expiring in 2 minutes! Please proceed to complete your payment.</p>
          </Modal.Body>
          <Modal.Footer>
            <Button style={{ backgroundColor: '#0A3161' }} onClick={handleExtendSession}>
              Extend Session
            </Button>
            <Button style={{ backgroundColor: '#0A3161' }} onClick={handlePopupClose}>
              OK
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      <Row className="justify-content-center ">

        <Col xs={12} md={8}>
          <Card className="col-md-12 card-section mt-4 mx-auto" style={{ maxWidth: '100%', position: 'relative' }}>
            <div className="justify-content-center " style={{ backgroundColor: '#b31942', padding: '10px' }}>
              <Col xs="auto" className="text-start">
                <h5 className="text-white">SBWC Electronic Payments</h5>
              </Col>
            </div>

            <div style={{ padding: '30px' }}>
              <div className="w-100">
                <h4 className="mb-4 mt-2" style={{ color: '#0A3161' }}>EDIS Penalty Payment</h4>
                <div style={{ padding: '20px' }}>
                  <Row className="justify-content-start mb-2" >
                    <Col className="text-start">
                      <h5 style={{ color: '#0A3161' }}>
                        <strong >Invoice Search:</strong>
                      </h5>
                      {error && <p style={{ color: 'red' }}>{error}</p>}
                    </Col>
                  </Row>

                  {/* Invoice Search Form */}
                  <Row className="justify-content-start">
                    <Col xs={12} sm={6} className="mb-3 mt-2 ">
                      <div className="p-field">
                        <FloatLabel>
                          <label htmlFor="invoiceNumber" style={{ color: '#0A3161' }}>Invoice Number</label>
                          <InputText
                            id="invoiceNumber"
                            name="invoiceNumber"
                            value={formData.invoiceNumber}
                            onChange={handleChange}
                            required
                          />
                        </FloatLabel>
                        <div className='text-start'>
                          {errors.invoiceNumber && <small style={{ color: 'red' }}>{errors.invoiceNumber}</small>}</div>
                      </div>
                    </Col>
                    {/* </Row> */}
                    {/* <Row className="justify-content-start"> */}
                    <Col xs={12} sm={6} className="mb-3 mt-2">
                      <div className="p-field">
                        <FloatLabel>
                          <label htmlFor="referenceNumber" style={{ color: '#0A3161' }}>Reference Number</label>
                          <InputText
                            id="referenceNumber"
                            name="referenceNumber"
                            value={formData.referenceNumber}
                            onChange={handleChange}
                          />
                        </FloatLabel>
                        <div className='text-start'>
                          {errors.referenceNumber && <small style={{ color: 'red' }}>{errors.referenceNumber}</small>}</div>
                      </div>
                    </Col>
                  </Row>

                  {/* Buttons for Search and Reset */}
                  <Row className="justify-content-center mt-3">
                    <Col xs="auto" className="mb-2">
                      <Button
                        label="Reset"
                        type="reset"
                        className="p-button-info"
                        onClick={handleReset}
                        style={{ backgroundColor: '#0A3161' }}
                        icon={<RiRestartFill size={20} />}
                        disabled={loading}
                      />
                    </Col>
                    <Col xs="auto" className="mb-2">
                      <Button
                        label={loading ? 'Loading...' : 'Search'}
                        type="button"
                        className="p-button-info"
                        style={{ backgroundColor: '#0A3161' }}
                        icon={<FaCheck />}
                        disabled={loading}
                        onClick={fetchInvoiceData}
                      />
                    </Col>
                  </Row>
                </div>
              </div>
              <p className="text-black text-start">Your invoice details will be displayed here after you've provided invoice number, payment reference number, and clicked "Search Invoice".</p>

              {/* Invoice Details Section */}
              {submittedData && submittedData.length !== 0 && (
                <div>
                  <h2 className="text-start text-black">Invoice Details</h2>

                  <DataTable value={submittedData} responsiveLayout="stack" className='custom-table'>
                    <Column field="invoiceNumber" header="Invoice Number" body={(rowData) => rowData.invoiceNumber} />
                    <Column field="invoiceDate" header="Invoice Date" body={(rowData) => rowData.invoiceDate} className='nowrap-cell' />
                    <Column field="complianceCaseDisplayNumber" header="Case Number" body={(rowData) => rowData.complianceCaseDisplayNumber} className='nowrap-cell' />
                    <Column field="legalBusinessName" header="Legal Business Name" body={(rowData) => rowData.legalBusinessName} />
                    <Column field="address" header="Physical Address" body={(rowData) => rowData.address} className='wide-address' />
                  </DataTable>
                  <div style={{ marginTop: '2rem' }}></div>

                  <DataTable value={submittedData} responsiveLayout="stack" className='custom-table'>
                    <Column field="invoiceAmount" header={
                      submittedData.some(
                        row => row.paymentStatus?.toLowerCase() === 'paid'
                      )
                        ? 'Invoice Amount'
                        : 'Due Amount'
                    } body={(rowData) => formatNumberWithCommas(`${rowData.invoiceAmount}`)} />
                    {submittedData.some(row => row.paymentStatus?.toLowerCase() !== 'paid') && (
                      <Column field="dueDate" header="Due Date" body={(rowData) => rowData.dueDate} className='nowrap-cell' />
                    )}
                    {submittedData.some(row => row.paymentStatus?.toLowerCase() === 'paid') && (
                      <Column field="paymentDate" header="Last Payment Date" body={(rowData) => rowData.paymentDate} className='nowrap-cell' />
                    )}


                    <Column field="paymentStatus" header="Payment Status" body={(rowData) => rowData.paymentStatus} />
                    {hasPenalty && (
                      <Column
                        field="penaltyAmount"
                        header="Penalty Amount"
                        body={(rowData) =>formatNumberWithCommas(`${rowData.penaltyAmount}`)}
                      />
                    )}

                    {hasDiscount && (
                      <Column
                        field="discountAmount"
                        header="Discount Amount"
                        body={(rowData) => formatNumberWithCommas(`${rowData.discountAmount}`)}
                      />
                    )}

                    {showFinalAmount && (
                      <Column
                        field="finalDueAmount"
                        header="Final Amount"
                        body={(rowData) => formatNumberWithCommas(`${rowData.finalDueAmount}`)}
                      />
                    )}
                  </DataTable>

                  <div>
                    {invoiceData.paymentStatus?.toLowerCase().includes('past due') && (
                      <p style={{ color: 'red' }}>*10% penalty assessed for overdue</p>
                    )}
                  </div>
                  <div>
                    {invoiceData.email && (
                      <p className="text-center">A copy of this receipt is sent to email: {invoiceData?.email}</p>
                    )}
                  </div>
                  <div>               {/* Buttons Section */}
                    {invoiceData.paymentStatus !== 'Paid' && (
                      <>
                        <div>

                          <p style={{ color: 'red' }}>*A service fee of {invoiceData.serviceFee}% will be added to all credit card transactions.</p>

                        </div>
                        <Row>
                          <Col xs={12} sm={6} className="mb-3 mt-5">

                            <FloatLabel>
                              <label htmlFor="companyEmail" style={{ color: '#0A3161' }}>Email</label>
                              <InputText
                                id="companyEmail"
                                name="companyEmail"
                                value={invoiceData.companyEmail}
                                onChange={handleEmailChange}
                                required
                              />
                            </FloatLabel>

                            {emailError && <small className="p-error">{emailError}</small>}
                          </Col>
                          <Col xs={12} sm={6} className="mb-3 mt-5">
                            <FloatLabel>
                              <Dropdown
                                id="paymentMethod"
                                name="paymentMethod"
                                options={paymentMethodOptions}
                                value={paymentMethod}
                                onChange={(e) => handleDropdownChange(e, 'paymentMethod')}
                                className={'custom-input'}
                              />
                              <label htmlFor="paymentMethod" style={{ color: '#0A3161', }}>Payment Method</label>
                            </FloatLabel>
                            {paymentMethodError && <small className="p-error">{paymentMethodError}</small>}
                          </Col>

                        </Row>
                        <Row className="justify-content-center mt-3">
                          <Col xs="auto" className="mb-2">   </Col>
                          <Col xs="auto" className="mb-2">
                            <Button
                              label={<><i className="bi bi-currency-dollar" ></i>Proceed to Payment</>}
                              className="p-button-info"
                              style={{ backgroundColor: '#0A3161', height: '100%' }}
                              onClick={handleProceedToPayment}

                            />
                          </Col>
                          <Col xs="auto" className="mb-2"> </Col>
                        </Row>
                      </>
                    )}
                    <Row className="justify-content-center mt-3">
                      <Col xs="auto" className="mb-2">
                        <Button
                          label={<><i className="bi bi-houses-fill"></i> Payments Home</>}
                          className="p-button-info"
                          style={{ backgroundColor: '#0A3161', height: '100%' }}
                          onClick={handlePaymentsHome}
                        />
                      </Col>
                      <Col xs="auto" className="mb-2"></Col>
                      <Col xs="auto" className="mb-2">
                        <Button
                          className="p-button-info"
                          style={{ backgroundColor: '#0A3161' }}
                          onClick={handleToSBWCPage}>
                          <img src={`${MEDIA_URL}logo_sbwc.jpg`} alt="Go to SBWC" className="logo img-fluid" style={{ width: '30px', height: '30px', marginRight: '8px' }} />
                          Go to SBWC
                        </Button>
                      </Col>
                    </Row>
                  </div>
                </div>

              )}
            </div>
          </Card>
        </Col>
      </Row>

    </div>
  );
};

export default EdisPaymentComponent;
